/* eslint-disable import/prefer-default-export */
import EzUser from 'init/init-user';

export const subId1Suffix = () => {
  const { splitTestName, splitTestVariant } = EzUser;

  if (!splitTestName || !splitTestVariant) return '';

  return `-${splitTestName}-${splitTestVariant}`;
};
